export const genericReducer =
    (initialState, reductionLookup) =>
    (state, { type, payload, meta }) => {
        const activeState = state === undefined ? initialState : state;
        const reducer = reductionLookup[type];
        return !(typeof reducer === 'function') ? activeState : reducer(activeState, payload, meta);
    };

export default genericReducer;
